import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { IBackendCartEntries } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import priceForCartEntry from 'utils/menu/price-for-cart-entry';

import { EntryDescriptionRow, Item, ItemName, ItemPrice, ItemQuantityBadge } from './styled';

interface ICartEntry {
  entry: IBackendCartEntries;
  currencyFormatter: Function;
}

export const CartEntry = ({ entry, currencyFormatter }: ICartEntry) => {
  const { formatMessage } = useIntl();
  const resolveChild = (child: IBackendCartEntries, i: number): React.ReactNode =>
    child.children && child.children.length > 0 ? (
      child.children.map(resolveChild)
    ) : (
      <EntryDescriptionRow key={child.name! + i}>
        {child.name}
        {child.price ? ` - ${currencyFormatter(child.price)}` : ''}
      </EntryDescriptionRow>
    );

  return (
    <Item>
      <ItemQuantityBadge quantityText={formatMessage(messages.qty)}>
        {entry.quantity || 1}
      </ItemQuantityBadge>
      <ItemName>{entry.name}</ItemName>
      {entry.children && entry.children.map(resolveChild)}
      <ItemPrice>
        <Currency amount={priceForCartEntry(entry)} />
      </ItemPrice>
    </Item>
  );
};
const messages = defineMessages({
  qty: {
    id: 'qty',
    defaultMessage: 'Qty: ',
    description: 'Text cart counter (abbreviation)',
  },
});
